export default "__VITE_ASSET__72db6ab5__"